import React, { useEffect, useState } from 'react';
import { Box, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, TablePagination } from '@mui/material';
import { getEmployees, /*deleteEmployee */ } from '../../api/axios';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
//import EditEmployeeModal from '../EditEmployee/EditEmployeeModal';
import { useTranslation } from 'react-i18next';
import './employees.css';

const Employees = () => {  
  const [employees, setEmployees] = useState([]);
  const [columns, setColumns] = useState([]);
  const [page, setPage] = useState(0); // Trenutna stranica
  const [rowsPerPage, setRowsPerPage] = useState(10); // Broj redova po stranici

  const [open, setOpen] = useState(false); // State za modal
  const [editingEmployee, setEditingEmployee] = useState(null); //Korisnik koji se edituje
  const [isDeleting, setIsDeleting] = useState(false);

  const { t } = useTranslation('global');

  const columnDisplayNames = {
    username: t('employees.username'),
    name: t('employees.name'),
    lastname: t('employees.lastname'),
    card_serial: t('employees.cardSerial'),
  };

  useEffect(() => {
    const fetchEmployees = async () => {
      try {
        const accessToken = localStorage.getItem("accessToken");
        const employeesRaw = await getEmployees(accessToken);
        const employeesData = employeesRaw.data;
        console.log(employeesData);
        if (Array.isArray(employeesData.employees)) {
          setEmployees(employeesData.employees);
          if (employeesData.employees.length > 0) {
            setColumns(Object.keys(employeesData.employees[0]));
          }
        } else {
          console.error("Expected employeesData.employees to be an array, got:", employeesData.employees);
          setEmployees([]);
        }
      } catch (error) {
        console.error('Error fetching employees:', error);
        setEmployees([]);
      }
    };

    fetchEmployees();
  }, []);

  // Funkcije za paginaciju
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0); // Resetuje na prvu stranicu
  };

  return (
    <Box sx={{ maxWidth: 1200, margin: 'auto' }}>
      <TableContainer component={Paper}>
        <Table className="employeesTable">
          <TableHead>
            <TableRow className="tableHeader">
              <TableCell style={{ fontWeight: 'bold' }}>#</TableCell>
              {columns
                .filter(column => ['username', 'name', 'lastname', 'card_serial'].includes(column))
                .map((column) => (
                  <TableCell key={column} style={{ fontWeight: 'bold' }}>
                    {columnDisplayNames[column] || column}
                  </TableCell>
                ))}
              <TableCell style={{ fontWeight: 'bold' }}>{t('employees.actions')}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {Array.isArray(employees) && employees.length > 0 ? (
              employees
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage) // Prikaz samo redova za trenutnu stranicu
                .map((employee, index) => (
                  <TableRow key={employee.id} className="stripedRow">
                    <TableCell>{page * rowsPerPage + index + 1}</TableCell>
                    {columns
                      .filter(column => ['username', 'name', 'lastname', 'card_serial'].includes(column))
                      .map((column) => (
                        <TableCell key={column}>
                          {employee[column]}
                        </TableCell>
                      ))}

                    <TableCell>
                      <Button
                        /*onClick={() => handleEdit(employee.id)}*/
                        className="actionButtonIcon"
                      >
                        <EditIcon />
                      </Button>

                      <Button
                        /*onClick={() => handleDelete(employee.id)}*/
                        className="actionButtonIcon delete"
                      >
                        <DeleteIcon />
                      </Button>
                    </TableCell>
                  </TableRow>
                ))
            ) : (
              <TableRow>
                <TableCell colSpan={columns.length + 2}>{t('employees.noEmployeesFound')}</TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Paginacija */}
      <TablePagination
        rowsPerPageOptions={[5, 10, 25, 50]}
        component="div"
        count={employees.length} // Ukupan broj redova
        rowsPerPage={rowsPerPage} // Broj redova po stranici
        page={page} // Trenutna stranica
        onPageChange={handleChangePage} // Promena stranice
        onRowsPerPageChange={handleChangeRowsPerPage} // Promena broja redova po stranici
        labelRowsPerPage={t("employees.rowsPerPage")}
      />

      {
        //open && editingEmployee && (
        //<EditEmployeeModal open={open} setOpen={setOpen} editingEmployee={editingEmployee} setEditingEmployee={setEditingEmployee} setemployees={setemployees} employees={employees} />
        //)
      }
    </Box>
  );
};

export default Employees;
